const RELEASE_CONFIGS = {
  v253: {
    gda: {
      curatedSources: [
        { name: 'UniProt/SwissProt (UniProt)', url: 'https://www.uniprot.org/' },
        { name: 'ClinVar', url: 'https://www.ncbi.nlm.nih.gov/clinvar/' },
        { name: 'PsyGeNET', url: 'https://pubmed.ncbi.nlm.nih.gov/25964630/' },
        { name: 'Orphanet', url: 'https://www.orpha.net/consor/cgi-bin/index.php' },
        { name: 'GenCC', url: 'https://search.thegencc.org/' },
        { name: 'The Clinical Genome Resource', url: 'https://www.clinicalgenome.org/', label: 'ClinGen' },
        { name: 'MGD', url: 'https://www.informatics.jax.org/', label: 'MGD human' },
        { name: 'RGD', url: 'https://rgd.mcw.edu/', label: 'RGD human' },
      ],
    },
    vda: {
      curatedSources: [
        { name: 'UniProt/SwissProt', url: 'https://www.uniprot.org/' },
        { name: 'ClinVar', url: 'https://www.ebi.ac.uk/gwas/' },
        { name: 'Phewas Catalog', url: 'https://phewascatalog.org/' },
        { name: 'NHGRI-EBI GWAS Catalog', url: 'https://www.ebi.ac.uk/gwas/' },
        { name: 'ClinGen Variants', url: 'https://erepo.clinicalgenome.org/evrepo/', label: 'ClinGen Evidence Repository for Variants' },
      ],
    },
  },
  v254: {
    gda: {
      curatedSources: [
        { name: 'UniProt/SwissProt (UniProt)', url: 'https://www.uniprot.org/' },
        { name: 'ClinVar', url: 'https://www.ncbi.nlm.nih.gov/clinvar/' },
        { name: 'PsyGeNET', url: 'https://pubmed.ncbi.nlm.nih.gov/25964630/' },
        { name: 'Orphanet', url: 'https://www.orpha.net/consor/cgi-bin/index.php' },
        { name: 'GenCC', url: 'https://search.thegencc.org/' },
        { name: 'The Clinical Genome Resource', url: 'https://www.clinicalgenome.org/', label: 'ClinGen' },
        { name: 'MGD', url: 'https://www.informatics.jax.org/', label: 'MGD human' },
        { name: 'RGD', url: 'https://rgd.mcw.edu/', label: 'RGD human' },
        { name: 'ClinPGX', url: 'https://www.clinpgx.org/' },
      ],
    },
    vda: {
      curatedSources: [
        { name: 'UniProt/SwissProt', url: 'https://www.uniprot.org/' },
        { name: 'ClinVar', url: 'https://www.ebi.ac.uk/gwas/' },
        { name: 'Phewas Catalog', url: 'https://phewascatalog.org/' },
        { name: 'NHGRI-EBI GWAS Catalog', url: 'https://www.ebi.ac.uk/gwas/' },
        { name: 'ClinGen Variants', url: 'https://erepo.clinicalgenome.org/evrepo/', label: 'ClinGen Evidence Repository for Variants' },
        { name: 'ClinPGX', url: 'https://www.clinpgx.org/' },
      ],
    },
  },
};

export const getReleaseConfig = () => {
  const version = process.env.REACT_APP_RELEASE_VERSION || 'v253';
  return RELEASE_CONFIGS[version] || RELEASE_CONFIGS.v253;
};

export default getReleaseConfig;
